import { PrivacyPolicy } from "@/features/misc";
import Head from "next/head";

export default function PrivacyPolicyPage() {
	return (
		<>
			<Head>
				<title>プライバシーポリシー | ケアミー</title>
			</Head>

			<PrivacyPolicy />
		</>
	);
}
